import Image from "next/image"
import { HttpTypes } from "@medusajs/types"

import { CartDropdown, MobileNavbar, Navbar } from "@/components/cells"
import { HeartIcon, MessageIcon } from "@/icons"
import { listCategories } from "@/lib/data/categories"
import { PARENT_CATEGORIES } from "@/const"
import { retrieveCart } from "@/lib/data/cart"
import { UserDropdown } from "@/components/cells/UserDropdown/UserDropdown"
import { retrieveCustomer } from "@/lib/data/customer"
import { countRegionWishlistProducts, getUserWishlists } from "@/lib/data/wishlist"
import { Wishlist } from "@/types/wishlist"
import { Badge } from "@/components/atoms"
import CountrySelector from "@/components/molecules/CountrySelector/CountrySelector"
import { listRegions } from "@/lib/data/regions"
import LocalizedClientLink from "@/components/molecules/LocalizedLink/LocalizedLink"
import { MessageButton } from "@/components/molecules/MessageButton/MessageButton"
import { SellNowButton } from "@/components/cells/SellNowButton/SellNowButton"
import { getTranslate } from "@/tolgee/server"    
import { getLanguage } from "@/tolgee/language";
import { getProductTranslations } from "@/lib/data/translations";
import { applyTranslations } from "@/lib/utils";

export const Header = async () => { 
  const t = await getTranslate()
  const locale = await getLanguage();

  const cart = await retrieveCart().catch(() => null)
  // 对购物车中商品标题应用翻译
  let translatedCart = cart
  if (cart?.items?.length && locale) {
    const productIds = cart.items.map((item) => item.product_id).filter(Boolean) as string[]
    if (productIds.length) {
      const translations = await getProductTranslations(productIds, locale)
      translatedCart = {
        ...cart,
        items: cart.items.map((item) => {
          const productTranslations = translations[item.product_id]
          if (productTranslations) {
            // 翻译 API 返回 title，但 cart item 中字段是 product_title
            const mappedTranslations = {
              product_title: productTranslations.title,
            }
            return applyTranslations(
              { ...item, translations: { [locale]: mappedTranslations } },
              locale
            )
          }
          return item
        }),
      }
    }
  }
  const user = await retrieveCustomer()
  let wishlist: Wishlist[] = []
  if (user) {
    const response = await getUserWishlists()
    wishlist = response.wishlists 
  }
 
  const regions = await listRegions()

  const wishlistCount = user
    ? await countRegionWishlistProducts(locale, wishlist)
    : 0

  const { categories, parentCategories } = (await listCategories({
    headingCategories: PARENT_CATEGORIES,
    countryCode: locale,
  })) as {
    categories: HttpTypes.StoreProductCategory[]
    parentCategories: HttpTypes.StoreProductCategory[]
  }

  return (
    <header className="relative left-1/2 -translate-x-1/2 w-screen">
      <div className="max-w-[1920px] mx-auto w-full lg:px-6 xl:px-8 2xl:px-[120px]">
        <div className="flex py-2">
          <div className="flex items-center lg:w-1/3">
            <MobileNavbar
              parentCategories={parentCategories}
              childrenCategories={categories}
            />
            <div className="hidden lg:block">
              {/* <SellNowButton /> */}
            </div>
          </div>
          <div className="flex lg:justify-center lg:w-1/3 items-center pl-4 lg:pl-0 flex-shrink-0">
            <LocalizedClientLink href="/" className="text-2xl font-bold flex items-center">
              {/* <img src="/fbe/logo_3.png" className="h-[50px]"></img> */}
              <img src="/logo.svg" className="h-[50px]"></img>
              {/* <Image
                src="/fbe/logo_3.png"
                width={150}
                height={50}
                alt={t("header.logo_alt")}
                priority
              /> */}
            </LocalizedClientLink>
          </div>
          <div className="flex items-center justify-end gap-2 lg:gap-4 flex-1 lg:w-1/3 py-2">
            {user && <MessageButton />}
            <UserDropdown user={user} />
            {user && (
              <LocalizedClientLink href="/user/wishlist" className="relative">
                <HeartIcon size={20} />
                {Boolean(wishlistCount) && (
                  <Badge className="absolute -top-2 -right-2 w-4 h-4 p-0">
                    {wishlistCount}
                  </Badge>
                )}
              </LocalizedClientLink>
            )}

            <CartDropdown cart={translatedCart} />
            <CountrySelector regions={regions} />
          </div>
        </div>
        <Navbar categories={parentCategories} />
      </div>
    </header>
  )
}
